import React from "react";
import { Select, FormField, ErrorMessage, InfoIcon } from "@vwfs-bronson/bronson-react";
import { getIn } from "formik/dist/index";

export function SelectField({ field, form, label, tooltip, notion, ...props }) {
  const error =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  const id = props.id || field.name;

  return (
    <FormField
      type="other"
      labelText={label}
      id={id}
      infoIcon={tooltip && <InfoIcon icon="semantic-info">{tooltip}</InfoIcon>}
      notion={notion}
      labelElement="div"
      noFloatingLabel
      errorMessage={error ? <ErrorMessage id={id}>{error}</ErrorMessage> : null}
    >
      <Select {...props} {...field} id={id} error={!!error} />
    </FormField>
  );
}
